export const OBSERVATIONS_MAX_LENGTH = 2000;
